import * as packageData from '../../package.json' assert { type: 'json' };

export const Constants = {
  DATA_COMPONENT_OBJECT: 'data-component-object',
  DATA_PRODUCT_CODE: 'data-product-code',
  DATA_PRODUCT_NAME: 'data-product-name',
  DATA_VEHICLE: 'data-vehicle',
  DATA_COUNTRY: 'data-country',
  DATA_LANGUAGE: 'data-language',
  DATA_AUDIENCE: 'data-audience',
  DADA_ENDPOINT: 'dada-endpoint',
  DADA_APIKEY: 'dada-apikey',
  ASSETS_DOMAIN: 'assets-domain',
  PRODUCT_COMPONENT_LIBRARY_VERSION: 'product-component-library-version',
  POP_VERSION: 'pop-version',
  VERSION: packageData.version,
  POP_BASE_TILE_TAG_NAME: 'pop-base-tile-component',
} as const;
